import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getSummaryDimensions } from "../../../selectors";
import { Col, Row } from "antd";
import { mapping as dimensionsMapping } from "../../../summary/dimensions";
import { computeColSpans } from "./Dimension";
import moment from "moment";
import { isStartDateRef } from "../../../utils";

export const periodToTitle = (period = []) => {
  const startDate = moment(period[0]) || moment();
  const endDate = moment(period[1]) || moment();

  if (isStartDateRef(startDate)) {
    return `${endDate.format("DD/MM/YYYY")}`;
  } else {
    return `Du ${startDate.format("DD/MM/YYYY")} au ${endDate.format("DD/MM/YYYY")}`;
  }
};

const getDimensionLabel = dimensionId => {
  const dim = dimensionsMapping.find(v => v.id === dimensionId) || {};
  return dim.label || "";
};

const Title = props => {
  const label = props.label || "";
  return <div className={"p-page-subtitle"}>{label}</div>;
};

const DimensionsTitle = props => {
  const dimensions = props.dimensions || [];
  const period = props.period || [moment(), moment()];
  const periodToCompare = props.periodToCompare || [moment(), moment()];
  const isComparing = props.isComparing || false;
  const { colTitle, colDiff, colValue } = computeColSpans(props.fullWidth, isComparing, dimensions.length);

  let titlePeriod = "";
  let titlePeriodToCompare = "";
  if (isComparing) {
    titlePeriod = periodToTitle(period);
    titlePeriodToCompare = periodToTitle(periodToCompare);
  }
  return (
    <Row gutter={16}>
      {dimensions.map((v, i) => {
        return (
          <Col span={colTitle} key={i}>
            <Title label={getDimensionLabel(v)} />
          </Col>
        );
      })}
      {isComparing && (
        <Fragment>
          <Col span={colValue}>
            <span style={{ display: "flex" }}>
              <Title label={titlePeriod} />
            </span>
          </Col>

          <Col span={colValue}>
            <span style={{ display: "flex" }}>
              <Title label={titlePeriodToCompare} />
            </span>
          </Col>
          <Col span={colDiff}>
            <span style={{ display: "flex" }}>
              <Title label={"Evolution"} />
            </span>
          </Col>
        </Fragment>
      )}
    </Row>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    dimensions: getSummaryDimensions(state)
  };
};

export default connect(mapStateToProps)(DimensionsTitle);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Dimension/DimensionsTitle.js